export const wxurl='http://xgzx.talkmed.com'                //前端域名
export const Wechatauth='/webapi/wechatauth'                //授权
export const Login='/webapi/login'                          //登录
export const Register='/webapi/users/update' 					//注册

export const BindMobile='/webapi/users/bindmobile' 				//绑定手机号
export const BindEmail='/webapi/users/bindemail' 				//绑定

export const Citys='/webapi/regions/citys'					//全国城市
export const CitySearch='/webapi/regions/search'			//城市搜索
export const Provinces='webapi/regions/address'                      //省市
export const Signature='/webapi/signature'					//获取聊天室签名
export const SendCode='/webapi/sendcode'					//发送验证码							
export const GetUserInfo='/webapi/user'							//获取用户信息
export const Logout='/webapi/logout'						//退出
export const ModulesRecommend='/webapi/modules/banner'      //模块推荐
export const OverallSearch='/webapi/modules/search'          //全局搜索
export const IndexSearch='/webapi/modules/index_search'
export const ModulesDetails = '/webapi/modules/show'   //模块详情
export const ModulesArticles='/webapi/modules/articles'         //模块文章
//首页
// export const IndexActivity='/webapi/activities'              //活动

//会议
export const MeetingRecent='/webapi/meetings'				//近期会议
export const MeetingHistory='/webapi/meetings/history'				//历史会议
export const MeetingMonth='/webapi/meetings/month'				//当月会议
export const MeetingRegions='/webapi/regions'					//会议地区
export const MeetingsSearch='/webapi/meetings/search'          //会议搜索
export const MeetingsPlaceSearch='/webapi/meetings/address'    //地区会议搜索
export const MeetingsRecommend='/webapi/meetings/recommonds'    //会议推荐
export const MeetingsDetails='/webapi/meetings/show'            //会议详情
export const MeetingPermission='/webapi/meetings/permission'    //看会议详情是否需要密码
export const MeetingPassword='/webapi/meetings/password'    //看会议详情是否需要密码
export const MeetingsPlace='/webapi/meetings/sessions'        //会议会场
export const MeetingsPlaceDetails='/webapi/sessions/show'		//会场详情
export const MeetingsCarousel='/webapi/meetings/images'         //会议轮播
export const MeetingsCollectInfo='/webapi/meetings/extendColumns'   //会议收集信息
export const MeetingsSumbitInfo='/webapi/meetings/submitExtendColumns'        //会议信息提交
export const MeetingsAuthList='/webapi/sessions/departAndAgeAndJob'   //科室-年龄-职称列表
export const CollectUserAuth='/webapi/sessions/collect/user/profile'   //收集认证信息
export const MeetingFile='/webapi/meetings/Files'        //会议文件


export const MeetingsSchedule='/webapi/meetings/scheduletable'        //会议日程
export const MeetingScheduleDetails='/webapi/chapters/show'            //会场日程
export const MeetingFollows='/webapi/meetings/follows'			 //会议关注
export const MeetingButtons='/webapi/meetings/buttons'			//会议按钮
export const ExpertSpeakers='/webapi/meetings/writers'			//讲者信息
export const SessionsViewsNum='/webapi/sessions/views'              //会场观看人数
export const MeetingCompanyAreas='/webapi/meetings/companyAreas'
export const ExpertSpeakersInfo='/webapi/meetings/writerinfo'    //讲者详细信息
export const ExpertSearch='/webapi/writers/search'				//专家查询
export const ExpertSchedule='/webapi/writers/meeting_schedule'	//专家日程
export const ExpertInformation='/webapi/writers/info'			//专家信息
export const ExclusiveViewList='/webapi/meetings/articles'			//专家信息
export const MeetingChat='/webapi/sessions/comments'                //会议聊天
export const  MeetingchatList='/webapi/sessions/showAnonymousComments'   //会议匿名评论列表
export const  MeetinganonymousChat='/webapi/sessions/anonymousComments'   //会议匿名聊天
export const MeetingBanner='/webapi/sessions/banners'           //会议广告位
//注册收费
export const MeetingRegInfo='/webapi/meeting/reg/info'           //用户注册信息
export const MeetingReg='/webapi/meeting/reg'           //用户提交注册
export const MeetingUploadVoucher='/webapi/meeting/upload/voucher'  //上传支付凭证
export const MeetingUploadImg='/webapi/upload_img' //上传图片
export const MeetingOrderPayment='/webapi/order/payment' //调起支付
export const MeetingPayCheck='/webapi/meeting/pay/query' //支付结果查询
export const orderDetail='/webapi/meeting/order/query' //订单小票



// export const MeetingCollect='/webapi/users/meetingstatus'     //会议收藏
//文章
export const ArticlesDetails='/webapi/articles'						//文章
export const ArticlesAddComment='/webapi/articles/comment'			//添加评论
export const ArticlesComments='/webapi/articles/showcomment'		//查看评论
export const ArticlesLength='/webapi/columns/articlenum'			//文章数量
export const ArticlesCollect='/webapi/articles/follows'				//收藏文章
export const ArticlesAddRead='/webapi/articles/read'				//记录文章阅读
export const ArticlesImage='/webapi/articles/images';                //文章图片
//专栏
export const ColumnMyfollow='/webapi/users/myfollowcolumns'		  //我关注的专栏
export const ColumnList='/webapi/columns/index'        			  //专栏列表
export const ColumnDetails='/webapi/columns/show'            		//专栏详情
export const ColumnFollow='/webapi/columns/follows'              //关注或取消关注某专栏
export const ColumnRecommend='/webapi/columns/recommends'        //推荐专栏
export const ColumnSearch='/webapi/columns/search'               //专栏搜索
export const SearchArticles='/webapi/informationChannels/searcharticles'          //专栏搜索文章

export const ColumnChangeBatches='/webapi/columns/changebatches'    //换一批
//病例
export const CaseMajor='/webapi/subspecialties'					//亚专业
export const CaseArticles='/webapi/subspecialties/articles'		//亚专业文章
export const CaseSearch='/webapi/subspecialties/search'       //病例搜索
export const CaseAllArticles='/webapi/subspecialties/all_articles';    //病例所有文章
//前沿资讯
export const InformationChannels='/webapi/informationChannels'          //资讯频道
export const InformationMenu='/webapi/informationChannels/menu'	    //频道菜单
export const InformationDetails='/webapi/informationChannels/show'		//频道详情
export const InformationSwiper='/webapi/informationChannels/images'

//器械分类
export const InstrumentClassess='/webapi/deviceclasses'			//器械种类
export const InstrumentBrands='/webapi/brands'                  //器械品牌
export const InstrumentBrandClasses='/webapi/brands/deviceclasses'      //品牌器械分类
export const InstrumentDetails='/webapi/instruments/show'		//器械详情
export const InstrumentTables='/webapi/instruments/tables'       //器械型号
export const InstrumentCases='/webapi/instruments/cases'      //器械病例
export const InstrumentEvaluates='/webapi/instruments/evaluates'		//器械评估
export const InstrumentSearch='/webapi/instruments/index_search'		//器械搜索
export const InstClassesBanner='/webapi/deviceclasses/banners'		//器械种类banner
export const InstClassesBrands='/webapi/deviceclasses/brands'		//器械种类品牌
export const InstClassesInstrument='/webapi/deviceclasses/instruments'		//器械种类器械列表
//我的
export const PersoanalAttention='/webapi/users/myfollows';     //我的关注
export const PersoanalUserInfo='/webapi/user';     //個人信息
export const PersoanalLogout='/webapi/logout'      //退出
export const WxShare='/webapi/wechat/jssdkconfig'  //微信分享


export const CertificatesCheck='/webapi/user_certificates/check'    //证书检验
export  const   UploadCertificates='/webapi/user_certificates/upload'       //上传资格证书

//血管资讯会议系统
export  const   VascularRecommend='/webapi/meetings/recommend'       //会议推荐
export  const   VascularLogin='/webapi/mobile_code_login'       //手机号登陆或注册
export  const   VascularUserUpdate='/webapi/users/update'       //更新用户信息（身份认证）
export  const   MeetingWriters='/webapi/meetings/writers'       //会议讲者
export  const   WritersMeetingShedule='/webapi/writers/meeting_schedule'       //专家某场会议日程
export  const   WritersMeetings='/webapi/writers/meetings'       //专家所有会议
export  const   SystemNotice='/webapi/system_notices'       //系统通知列表
export  const   MeetingMessage='/webapi/meeting_messages'       //日程通知列表
export  const   HasRead='/webapi/has_not_read' //是否未读
export  const   UserRead='/webapi/user_system_notices' //已读
export  const   Hospitals='/webapi/hospitals'       //搜索医院列表
export  const   TaskBookDetail='/webapi/users/meeting_mission_statement'   //用户会议任务书
export  const   SearchWriters='/webapi/meetings/renpin_writers'   //专家检索
export  const   SearchAllWriters='/webapi/writers/ren_ping_search'   //专家检索

export  const   CompanyAreaSchedule='/webapi/company_areas/meeting_schedule'  //会议企业专区日程
export  const   MeetingsGroups='/webapi/meetings/groups'  //会议企业专区分组
export  const   CompanyAreaDetail='/webapi/companyAreas'  //会议企业专区分组
export  const   CompanySchedule='/webapi/company_areas/meeting_schedule'  //会议企业专区日程
export  const   MeetingInfo='/webapi/meetings/extends'  //会议企业专区日程
export  const   MeetingIsCollect='/webapi/meetings/is_follow'  //是否关注辞会议
export  const   OuterTask='/webapi/meeting_writer_mission_statement' //后台生成任务书
export  const   WriterRecord='/webapi/writers/details' //专家视频接口
export  const   RecordShow='/webapi/chapterDetail/:id' //视频详细信息
export  const   RecordCommentList='/webapi/chapter_details/:id/detail_comments' //视频评论列表
export  const   RecordComment='/webapi/detail_comments' //视频评论
export  const   Eposters='/webapi/meetings/wallposters' //壁报
export  const   PPTs='/webapi/meetings/ppts' //PPT
export  const   SendEmail='/webapi/send_user_statement' //PPT
export  const   countryPhoneCode='/webapi/country_phone_code' //国际区号
export  const   taskByTime='/webapi/users/meeting_mission_statement_bytime'
export  const   companyImages='/webapi/meetings/company_images'    //走马灯图片
export  const   ButtonDetail='/webapi/meeting_buttons/show'    //按钮详情
export  const   Manual='/webapi/meetings/manuals'    //手册
export  const   UpdateUserInfo='/webapi/users/update'  //资料修改
export  const   SendFileEmail='/webapi/send/file/email'  //发送文件下载邮件

export const followChannelsStatus='/webapi/informationChannels/isfavorite'   //频道列表的状态(用户是否关注)
export const formUserAnswers='/webapi/form_user_answers'   //专区表单提交
export const followChannels='/webapi/informationChannels/favorites'   //关注
export const Titles='/webapi/titles'   //职称
export const preWriters='/webapi/pre_writers'   //专家个人信息
export const topics='/webapi/topics'   //课题上报
export const inviteCode='/webapi/collect_codes/'   //课题上报
export const uploadImg='/webapi/upload_img'   //课题上报
export const recommends='/webapi/informationChannels/recommends'   //频道 推荐
export const articleRecommend='/webapi/articles/recommend'   //频道 推荐
export const meetingCustomOrganize='/webapi/meetings/custom_organizer'   //会议个性化单位
export const extendPop='/webapi/meetings/extend_info'   //会议弹出

export const treeTags='/webapi/tree_tags'   //会议弹出
export const mobileSchedule='/webapi/mobile_schedule'   //会议弹出
export const sendPPTEmail='/webapi/send_ppt_to_email'   //会议弹出

export const isSubscribe='/webapi/users/is_subscribe'   //判断是否关注服务号
export const previewLive='/webapi/users/preview_live'   //预约通知
export const cancelPreviewLive='/webapi/users/cancel_preview_live'   //取消预约

export const searchSchedule='/webapi/meetings/searchscheduletable'  //日程搜索

export const imgCode = '/webapi/imgcode'         //登录图形验证码

export const RegisterWiki='/webapi/register/medwiki'   //注册到medwiki
export const wantLookLive='/webapi/users/want_look_live'//直播-想看

export const RecordPlayUrl='/webapi/monitor/collect'//数据统计

export const VideoSubtitle="/webapi/session/video/subtitle" //录播视频字幕

export const MeetingCarouselSwiper="/webapi/meeting/act/carousel" //会议轮播

export const LiveVideoSubtitle="/webapi/session/live/subtitle"//直播视频字幕

export const PayInfoList="/webapi/meeting/pay/invoice"//支付发票列表

export const PayInfoUpdate="/webapi/meeting/pay/update/invoice"//支付发票修改

export const getCharpterAISummary="/webapi/chapter_detail/video/summarization"//录播摘要及关键词

export const SendEmailCode="/webapi/send/email/code" //发送邮箱验证码

export const EmailLogin="/webapi/email_code_login" //邮箱验证码登录


export const UserLabour="/webapi/meeting/user/labour" //劳务费-基础信息

export const UserLabourInvoice="/webapi/meeting/user/labour/invoice" //劳务费-提交发票

// 新域名接口 https://xgzxapi.talkmed.com
export const NEW_API_BASE = 'https://xgzxapi.talkmed.com'

// 会议详情 GET /meeting/{id}
export const NewMeetingDetail = (id) => `${NEW_API_BASE}/meeting/${id}`
// 会场日期列表 GET /meeting/{meeting_id}/days
export const NewMeetingDays = (meeting_id) => `${NEW_API_BASE}/meeting/${meeting_id}/days`
// 会议会场列表 GET /meeting/{id}/sessions
export const NewMeetingSessions = (id) => `${NEW_API_BASE}/meeting/${id}/sessions`
// 会场详情 GET /meeting/{meeting_id}/session/{session_id}/detail
export const NewSessionDetail = (meeting_id, session_id) => `${NEW_API_BASE}/meeting/${meeting_id}/session/${session_id}/detail`

// 会场日程列表 GET /meeting/{meeting_id}/session/{session_id}/chapter
export const NewSessionChapter = (meeting_id, session_id) => `${NEW_API_BASE}/meeting/${meeting_id}/session/${session_id}/chapter`

// 验证入会密码 post /meeting/verify/pwd
export const NewMeetingVerifyPwd = () => `${NEW_API_BASE}/meeting/verify/pwd`

//获取/修改专家信息
export const WriterInfoApi = () => `/webapi/meeting/writer/info`



// WEBPACK FOOTER //
// ./src/config/interface.js